import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  moreIcon: {
    cursor: 'pointer'
  }
}))
export default useStyles
